import styled from "styled-components"

export const ButtonRow = styled.div`
  display: grid;
  grid-auto-columns: max-content;
  grid-auto-flow: column;
  column-gap: 12px;
`
